import { useState, useEffect } from 'react';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { PointType } from '@packlink/packlink-sdk';

const useDropOffPoints = (from, serviceId, onFetch) => {
  const sdk = useSdk();
  const [loading, setLoading] = useState(true);
  const [dropOffPoints, setDropOffPoints] = useState([]);
  useEffect(() => {
    sdk.v1.dropOffs.all({
      city: from.city,
      code: from.alpha2Code,
      serviceId: serviceId,
      zip: from.zipCode,
      pointsType: PointType.PICK_UP
    }).then(allDropOff => setDropOffPoints(allDropOff)).catch(() => setDropOffPoints([])).finally(() => setLoading(false));
  }, [sdk, from, serviceId]);
  !loading && (onFetch === null || onFetch === void 0 ? void 0 : onFetch(dropOffPoints));
  return [dropOffPoints, loading];
};

export { useDropOffPoints };
//# sourceMappingURL=useDropOffPoints.js.map
